// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

// Styles
import BlogPostContentStyles from './blogPostContent.styles';

export default function BlogPostContent({ layout }) {
  const content = layout?.content;

  return <BlogPostContentStyles>{parse(content || '')}</BlogPostContentStyles>;
}

BlogPostContent.propTypes = {
  layout: PropTypes.shape({
    content: PropTypes.string,
  }),
};

BlogPostContent.defaultProps = {
  layout: {},
};
